
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1619"}},[_c('path',{attrs:{"data-name":"Rectangle 2342","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"Group 1621","transform":"translate(-760.379 -428.143)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2343","width":"16","height":"20","rx":"1","transform":"translate(762.379 428.143)","fill":"#adadad"}}),_c('path',{attrs:{"data-name":"Path 989","d":"M775.879 434.643h-.5v-2a1 1 0 10-2 0v2h-2v-2a1 1 0 10-2 0v2h-2v-2a1 1 0 10-2 0v2h-.5a1 1 0 000 2h.5v1a5.385 5.385 0 0010 0v-1h.5a1 1 0 000-2zm-7.5 4a1 1 0 01-1-1v-1h2v1a1 1 0 01-1 1zm5-1a1 1 0 01-2 0v-1h2z"}}),_c('path',{attrs:{"data-name":"Rectangle 2344","fill":"#fff","d":"M765.379 442.143h10v2h-10z"}})])])])
          )
        }
      }
    